'use strict'
const { name, version } = require('../package.json')
module.exports = { name, version }
